var map = {
	"./crmLogo.svg": [
		1053,
		3
	],
	"./logo_oson_crm.png": [
		1054,
		5
	],
	"./logo_oson_small.png": [
		1055,
		6
	],
	"./smartremontLogo.svg": [
		1056,
		4
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 492;
module.exports = webpackAsyncContext;